var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rosa" },
    [
      _vm._.size(_vm.calciatoriRosa) == 0
        ? _c("div", { staticClass: "recycle-scroller text-center" }, [
            _c("div", { staticClass: "navy--text text--darken-2" }, [
              _c(
                "div",
                { staticClass: "pa-4" },
                [
                  _c("v-icon", { staticClass: "navy--text text--darken-2" }, [
                    _vm._v("man "),
                  ]),
                  _vm._v(" "),
                  _c("v-icon", { staticClass: "navy--text text--darken-2" }, [
                    _vm._v("man "),
                  ]),
                  _vm._v(" "),
                  _c("v-icon", { staticClass: "navy--text text--darken-2" }, [
                    _vm._v("man "),
                  ]),
                  _vm._v(" "),
                  _c("v-icon", { staticClass: "navy--text text--darken-2" }, [
                    _vm._v("man "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.ruolo_id
                ? _c("div", [
                    _vm._v(
                      "\n        In questo pannello puoi scegliere quale calciatore (della tua rosa)\n        inserire negli slot della tua pianificazione. Se non vedi calciatori è\n        perchè o già sono stati tutti inseriti nei vari slot oppure non ne hai\n        ancora acquistato nessuno\n      "
                    ),
                  ])
                : _c("div", [_vm._v("Nessun calciatore in rosa")]),
            ]),
          ])
        : _c(
            "v-list",
            {
              staticClass: "recycle-scroller",
              class: { "nice-scroll": !_vm.is_mobile },
            },
            _vm._l(_vm.calciatoriRosa, function (calciatore, key) {
              return _c("calciatore", {
                key: key,
                attrs: {
                  id: key,
                  cal: calciatore,
                  borderAsRuolo: "",
                  showMainStatus: "",
                  ripple: _vm.ripple,
                  hideEditRemove: _vm.hideEditRemove,
                  hideImages: _vm.hideCalciatoriImages,
                  selected: _vm.onCalciatoreClick.bind(null, key),
                  remove: _vm.removeCalciatore.bind(null, key, _vm.id_squadra),
                  edit: _vm.showEditValore.bind(
                    null,
                    _vm.id_squadra,
                    calciatore.p,
                    key
                  ),
                },
              })
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }